import api from './axios';

export function buySubscription(data) {
  return api.post('/subscription/buy', data);
}

export function getActiveSubscription(userId) {
  return api.get(`/subscription/active/${userId}`);
}

export function recordAcademyOnlineSession(userId) {
  return api.post(`/subscription/academy/${userId}/online-session`);
}
// ارسال گزارش دستی توسط ادمین
export const createAdminManualReport = (formData) =>
  api.post('/report/admin/manual-report', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export function manualRenewSubscription(data) {
  // data شامل { userId, productType, days } خواهد بود
  return api.post('/subscription/manual-renew', data);
}
